import { FormControl, IconButton, InputLabel, ListSubheader, MenuItem, Select, Tooltip } from "@mui/material"
import { useCallback, useContext, useEffect, useState } from "react"
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import UserParametersContext from "./context"

const FieldList = (props) => {

	const { fields }						= useContext(UserParametersContext)
	const [currentFields, setCurrentFields]	= useState()
	const [selectedField, setSelectedField]	= useState({})
	const [isOpen, setIsOpen]				= useState(false)
	useEffect(() => {
		setSelectedField(props.value)
	}, [props.value])

	useEffect(() => {
		if (fields) {
			switch (props.variant) {
				case 'numeric' 	: setCurrentFields(fields.filter(f => f.type === 'numeric')); break;
				case 'growth'	: setCurrentFields(fields.filter(f => f.category === 'GROWTH')); break;
				default			: setCurrentFields(fields)
			}
		}

	}, [fields])

	const handleChange = useCallback((e) => {
		const field = fields.find(f => f.id === e.target.value)
		if (field) setSelectedField(field)
		if (props.onChange && field) props.onChange(field)
	}, [fields])

	let currentCategory = ''

	return (
		<FormControl fullWidth disabled={props.disabled ? true : false} error={props.error}>
			<InputLabel size={props.size || "medium"}>Campo</InputLabel>
			<Select
				label="Campo"
				value={selectedField?.id || ''}
				onChange={handleChange}
				size={props.size || "medium"}
				onOpen={() => setIsOpen(true)}
				onClose={() => setIsOpen(false)}
			>
				{currentFields && currentFields.map(f => {
					let currentItems = []

					if (currentCategory !== f.category) {
						currentCategory = f.category
						currentItems.push(<ListSubheader>{f.categoryDescription}</ListSubheader>)
					}

					currentItems.push(
						<MenuItem value={f.id} selected={f.id === props.field ? true : false} sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
							<span>{f.label}</span>
							{isOpen && f.description && (
								<Tooltip title={f.description}>
									<IconButton size="small" sx={{ ml: 1 }}>
										<HelpOutlineIcon fontSize="small" />
									</IconButton>
								</Tooltip>
							)}
						</MenuItem>
					)

					return currentItems
				})}
			</Select>
		</FormControl>
	)

}

export default FieldList